import { render, staticRenderFns } from "./SimulacrumSlot.vue?vue&type=template&id=294b3c6b&scoped=true"
import script from "./SimulacrumSlot.vue?vue&type=script&lang=js"
export * from "./SimulacrumSlot.vue?vue&type=script&lang=js"
import style0 from "./SimulacrumSlot.vue?vue&type=style&index=0&id=294b3c6b&prod&scoped=true&lang=css"
import style1 from "./SimulacrumSlot.vue?vue&type=style&index=1&id=294b3c6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b3c6b",
  null
  
)

export default component.exports